import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../tailwind/dialog";
import { Button } from "../../tailwind/button";
import { Input } from "../../tailwind/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../tailwind/select";
import { UserPlus, CheckCircle2 } from "lucide-react";

export const AddOptInDialog = ({ open, onOpenChange }) => {
  const [formData, setFormData] = useState({ name: '', phone: '', source: 'manual' });

  const handleSubmit = () => {
    // Logic to save would go here
    console.log("Saving:", formData);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <UserPlus className="h-5 w-5 text-emerald-600" />
            Add New Contact
          </DialogTitle>
        </DialogHeader>
        
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <label htmlFor="name" className="text-sm font-medium">Customer Name</label>
            <Input 
              id="name" 
              placeholder="John Doe" 
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
            />
          </div>
          
          <div className="grid gap-2">
            <label htmlFor="phone" className="text-sm font-medium">Phone Number</label>
            <Input 
              id="phone" 
              placeholder="+91 98765 43210" 
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
            />
          </div>

          <div className="grid gap-2">
            <label htmlFor="source" className="text-sm font-medium">Opt-in Source</label>
            <Select 
              value={formData.source} 
              onValueChange={(val) => setFormData({...formData, source: val})}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select source" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="manual">Manual Entry</SelectItem>
                <SelectItem value="website">Website Form</SelectItem>
                <SelectItem value="pos">In-Store (POS)</SelectItem>
                <SelectItem value="support">Customer Support</SelectItem>
              </SelectContent>
            </Select>
          </div>
          
          <div className="bg-blue-50 p-3 rounded-md flex gap-2 text-xs text-blue-700">
            <CheckCircle2 className="h-4 w-4 shrink-0 mt-0.5" />
            <p>By adding this contact, you confirm they have explicitly consented to receive messages from your business.</p>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={handleSubmit} className="bg-emerald-600 hover:bg-emerald-700 text-white">
            Add Contact
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};